import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

export default function ViewAssignedDevicesPage() {
  const { company_id } = useParams();
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchAssignedDevices = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/superadmin/devices/sadmin/company/${company_id}`,
        {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      if (!res.ok) throw new Error('Failed to fetch assigned devices');
      const data = await res.json();
      setDevices(data.devices || []);
    } catch (err) {
      console.error(err);
      alert('Failed to load assigned devices');
    } finally {
      setLoading(false);
    }
  };

  const handleUnassign = async (device_id) => {
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/superadmin/companies/${company_id}/unassign-devices`,
        {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ device_ids: [device_id] })
        }
      );

      if (!res.ok) throw new Error('Unassign failed');
      const data = await res.json();
      alert(`🚫 Unassigned: ${data.unassigned_devices?.join(', ') || device_id}`);
      fetchAssignedDevices();
    } catch (err) {
      console.error(err);
      alert('Failed to unassign device');
    }
  };

  useEffect(() => {
    fetchAssignedDevices();
  }, []);

  return (
    <div style={{ padding: 20 }}>
      <h2>Assigned Devices to Company ID: {company_id}</h2>

      {loading ? (
        <p>Loading devices...</p>
      ) : devices.length === 0 ? (
        <p>No devices assigned to this company.</p>
      ) : (
        <table border="1" cellPadding="10" style={{ width: '100%', marginTop: 20 }}>
          <thead>
            <tr>
              <th>Device ID</th>
              <th>Device Name</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {devices.map((device) => (
              <tr key={device.device_id}>
                <td>{device.device_id}</td>
                <td>{device.device_name}</td>
                <td>{device.status}</td>
                <td>
                  <button onClick={() => handleUnassign(device.device_id)}>Unassign</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
